/* eslint-disable max-classes-per-file */
import { A365BackendModel as Model } from '../a365.backendmodel';
import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { A365Named } from '../base/a365Named';
import { ModelConstants } from '../model-constants';
import { IViolation } from '../base/annotation';
import { ActionConstants } from '../../constants/action-constants';
import { getGeneralNamePatterns } from '../../shared/utils/validation.util';

@Metamodel.model({
    name: 'Scope Job Properties'
})
export class ScopeJobProperties {
    @Metamodel.attribute({
        display: shellStringResources.Name
    })
    public name: string;

    @Metamodel.attribute({
        display: shellStringResources.ScopeScriptFilePath
    })
    public scriptPath: string;

    @Metamodel.attribute({
        display: shellStringResources.ScopeReferenceAndResourceFiles
    })
    public refFiles?: string[];

    @Metamodel.attribute({
        display: shellStringResources.RuntimeName
    })
    public runtimeName: string;

    @Metamodel.attribute({
        display: shellStringResources.ScopeScriptParameters
    })
    public scriptParameters?: { [key: string]: string };

    @Metamodel.attribute({
        display: shellStringResources.ScopeCustomProperties
    })
    public tags?: { [key: string]: string };

    @Metamodel.attribute({
        display: shellStringResources.StandardToken
    })
    public parallelism?: number;

    @Metamodel.attribute({
        display: shellStringResources.StandardTokenPercentage
    })
    public parallelismPercent?: number;

    @Metamodel.attribute({
        display: shellStringResources.EcoToken
    })
    public ecoTokenParallelism?: number;

    @Metamodel.attribute({
        display: shellStringResources.EcoTokenPercentage
    })
    public ecoTokenParallelismPercent?: number;

    @Metamodel.attribute({
        display: shellStringResources.DefaultTokenPolicy
    })
    public defaultTokenPolicy?: Model.DefaultTokenPolicy;

    @Metamodel.attribute({
        display: shellStringResources.NotificationRecipients
    })
    public notificationRecipients?: string;

    @Metamodel.attribute({
        display: shellStringResources.Priority
    })
    public priority: number;

    @Metamodel.attribute({
        display: shellStringResources.MaxUnavailability
    })
    public maxUnavailability: number;

    @Metamodel.attribute({
        display: shellStringResources.NebulaArguments
    })
    public nebulaArguments?: string;

    @Metamodel.attribute({
        display: shellStringResources.Configuration
    })
    public conf?: { [key: string]: string };
}

@Metamodel.model({
    name: ModelConstants.scopeJobDefinition,
    display: [shellStringResources.SynapseScopeJobDefinition, shellStringResources.SynapseScopeJobDefinitions],
    reusable: true,
    referable: true,
    validator: ScopeJobDefinition.validate,
    constraints: {
        name: {
            required: true,
            patterns: getGeneralNamePatterns(shellStringResources.SynapseScopeJobDefinition),
            uniqueModelName: true
        }
    },
    accessPublishConstraint: {
        writeResource: {
            action: ActionConstants.scopeJobDefinitionsWrite // FIXME: this is placeholder to unblock some of the checkAccess functions. Update it once scope permissions are determined.
        },
        deleteResource: {
            action: ActionConstants.scopeJobDefinitionsDelete
        }
    }
})
export class ScopeJobDefinition extends A365Named {
    public readonly useShellFolder: boolean = true;

    @Metamodel.attribute({
        display: shellStringResources.ScopeJobDefinitionTargetScopePool
    })
    public targetScopePool: string;

    @Metamodel.attribute({
        display: shellStringResources.ScopeJobDefinitionJobProperties
    })
    public jobProperties: ScopeJobProperties;

    public violations: string[];

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private static validate(owner: any): IViolation[] | undefined {
        const named = (owner && owner.named) as ScopeJobDefinition;

        if (named && named.violations) {
            return named.violations.map((violation) => ({
                context: owner,
                message: () => violation
            }));
        }

        return undefined;
    }
}
